module.exports = __webpack_public_path__ + "img/bwx_login_white.9275981e.png";